<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<multiselect
						v-model="departmentId"
						:options="departments"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						:multiple="true"
						:disabled="allDep"
						label="name"
						:placeholder="$t('pricing.department')"
						class="multiselect-pricing"
					/>
				</b-col>
				<b-col>
					<multiselect
						v-model="employeeId"
						:options="employees"
						label="name"
						track-by="id"
						:multiple="true"
						:allow-empty="true"
						:show-labels="false"
						class="multiselect-pricing"
						:custom-label="sellerCustomLabel"
						@search-change="getEmployees($event)"
						:placeholder="$t('sidebar.organization-structure.employees')"
					>
						<template slot="option" slot-scope="option">
							{{ sellerCustomLabel(option.option) }}
						</template>
					</multiselect>
				</b-col>
			</b-row>
			<b-row class="mb-3">
				<b-col cols="2">
<!--					<b-form-input v-model="persistent" type="number"/>-->
				</b-col>
				<b-col>
					<date-picker
						v-model="fromDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.fromDate')"
						valueType="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker
						v-model="toDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.toDate')"
						value-type="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col cols="3">
<!--					<download-excel v-if="items.length>0" size="sm" class="btn btn-success mr-2" :data="items" :fields="json_fields" worksheet="My Worksheet" :name="`КПИ с ${fromDate} по ${toDate}`">-->
<!--						<strong>{{$t('excel-export.download-excel')}}</strong>-->
<!--					</download-excel>-->
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-2"/>
					<b-button @click="print" variant="outline-dark" class="fa fa-print"/>
					<vs-dropdown vs-custom-content vs-trigger-click >
						<b-link href.prevent class="card-header-action btn-setting"	>
							<b-button  class="fa fa-th mr-2" variant="dark" style="padding: 8px;margin-top: -1px;width: 35px ;height: 35px"></b-button>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<vs-dropdown-item v-for="(ind, i) in fields" :key="i">
								<b-checkbox v-model="ind.visible">{{ind.label}}</b-checkbox>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</b-col>
			</b-row>
			<hr class="mt-1">
		</div>
		<b-card-body class="marginPage">
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col cols="3">
						<div style="font-size: 10px">DutyFree International</div>
					</b-col>
					<b-col cols="6" class="text-center">
						<h6><b>{{$t("report KPI")}} {{$t("c")}} {{ fromDate ? fromDate : '________' }} {{$t("po")}} {{ toDate ? toDate : '________' }}</b></h6>
					</b-col>
				</b-row>
				<b-row class="mt-4">
					<b-col>
						<b-table :items="items" :fields="computedFields" id="gridContainer" :busy="loading" :responsive="true" small bordered show-empty striped hover foot-clone no-footer-sorting label-sort-asc="" label-sort-desc="" label-sort-clear="">
							<template #table-busy>
								<div class="text-center my-2">
									<b-spinner small class="mr-2"/><strong>Loading...</strong>
								</div>
							</template>
							<template #cell(index)="data">
								{{ data.index+1 }}
							</template>
							<template #cell(full_name)="data">
								{{ data.item.fullName  }}
							</template>
							<template #cell(department)="data">
								{{ data.item.departmentName }}
							</template>
							<template #cell(Total_revenue)="data">
								{{ data.item.totalValue }}
							</template>
							<template #cell(Total_revenue1)="data">
								{{ data.item.value | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}
							</template>

							<template #foot(index)>
								{{""}}
							</template>
							<template #foot(full_name)>
								{{""}}
							</template>
							<template #foot(department)="data">
								<b>{{$t("Itogo")}}</b>
							</template>

							<template #foot(Total_revenue)="data">
								<b>{{ sumSaleInEur | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>
							</template>
							<template #foot(Total_revenue1)="data">
								<b>{{ sumSaleInUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>
							</template>
						</b-table>
						<b-button  class="float-right mt-1" v-if="items.length > 0" @click="excelExport1('gridContainer', 'Отчет KPI')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
					</b-col>
				</b-row>
			</b-overlay>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import {BTable, VBTable} from "bootstrap-vue";
import { BOverlay } from 'bootstrapVue2';
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "report-kpi",
	components: {Multiselect, BOverlay,VBTable, BTable},
	data() {
		return {
			items: [],
			fields: [
				{key: 'index', label: '№', class: 'text-center', visible: true},
				{key: 'full_name', label: this.$t("Employee_(full_name)"), class: 'text-center', visible: true,sortable: true},
				{key: 'department', label: this.$t('pricing.department'), class: 'text-center', visible: true,sortable: true},
				{key: 'Total_revenue', label: this.$t("Total_revenue"), class: 'text-center', visible: true,sortable: true},
				{key: 'Total_revenue1', label: this.$t("Total_revenue1"), class: 'text-center', visible: true,sortable: true},
			],
			json_fields: {
				"Ф.И.О": "fullName",
				"Подразделение": "departmentName",
				"Индивид. выр. в $": "totalValue",
				"Сумма бонусов от 0.5% общ. выручки в $": "value"
			},
			fromDate: null,
			toDate: null,
			employees: [],
			employeeId: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			allDep: false,
			loading: false,
			depIds: [],
			empIds: [],
			persistent: 0.5
		};
	},
	methods: {
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		async getEmployees(search) {
			await UsersService.getSellerEmployees(search).then(response => {
				this.employees = response.data
			})
		},
		sellerCustomLabel(seller) {
			return (
				seller.firstName +
				" " +
				seller.lastName +
				" " +
				seller.middleName
			);
		},
		print() {
			window.print();
		},
		getItems() {
			this.loading = true
			this.items = []
			if (this.persistent && this.persistent>0){}else {
				this.persistent = 0.5
			}
			if (this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					deps: this.depIds,
					employees: this.empIds,
					persistent: Number(this.persistent)
				}
				ReportService.getReportKpi(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: `Заполните ${this.$t('certificate.fromDate')} и ${this.$t('certificate.toDate')}`,
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
		this.getEmployees('');
	},
	computed: {
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},

		sumSaleInEur() {
			let sum = 0
			this.items.forEach(t => {
				if (t.totalValue)
					sum = sum + parseFloat(t.totalValue.toFixed(2))
			})
			return sum;
		},
		sumSaleInUzs() {
			let sum = 0
			this.items.forEach(t => {
				if (t.value)
					sum = sum + parseFloat(t.value.toFixed(2))
			})
			return sum;
		}
	},
	watch: {
		'departmentId': {
			handler(newValue) {
				this.depIds = []
				newValue.forEach(res => {
					this.depIds.push(res.id)
				})
			}
		},
		'employeeId': {
			handler(newValue) {
				this.empIds = []
				newValue.forEach(res => {
					this.empIds.push(res.id)
				})
			}
		}
	}
}
</script>

<style scoped>
@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.marginPage {
		margin: 0 30px 0 40px;
	}
}
</style>
